import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./styles/ServicesSection.css";

import CollaborationSolutions from "../../../assets/images/services/managed-services/collaborationSolutions.png";
import unifiedCommunicationpng from "../../../assets/images/services/managed-services/unifiedCommunicationpng.png";
import contactCenter from "../../../assets/images/services/managed-services/contactCenter.png";
import securitySolutions from "../../../assets/images/services/managed-services/securitySolutions.png";
import connectivity from "../../../assets/images/services/managed-services/connectivity.png";
import IntelligentSmartCitiesSolutions from "../../../assets/images/services/infrastructure-services/intelligentSmartCitiesSolutions.png";
import cloudinfra from "../../../assets/images/services/infrastructure-services/cloudInfra.png";
import MariTimes from "../../../assets/images/services/infrastructure-services/maritimeSystems.png";

const ServicesSection = () => {
  const containerRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const navigate = useNavigate();

  const services = [
    {
      title: "Collaboration Solutions",
      description:
        "ComNetworks.net’s Channel Partner Program enables partners to offer advanced UCaaS solutions that enhance business communication and support client growth.",
      icon: CollaborationSolutions,
      link: "/services/Collaboration-Solutions",
    },
    {
      title: "Unified Communications Service",
      description:
        "UCaaS (Unified Communications as a Service) enhances traditional VoIP by integrating voice with messaging, chat, video conferencing, screen sharing, and online meetings into one seamless communication platform.",
      icon: unifiedCommunicationpng,
      link: "/services/Unified-Communications",
    },
    {
      title: "Contact Center Service",
      description:
        "CCaaS (Contact Center as a Service) solutions go beyond voice calls by supporting digital channels like chat and SMS, while offering scalable, globally accessible, and easily integrated customer service routing.",
      icon: contactCenter,
      link: "/services/Contact-Center",
    },
    {
      title: "Security Solutions",
      description:
        "Our DDoS protection service safeguards digital assets and ensures uninterrupted operations, strengthened by advanced Syslog, SIEM, and next-generation firewall solutions.",
      icon: securitySolutions,
      link: "/services/Security-Solutions",
    },
    {
      title: "Connectivity",
      description:
        "Our software-defined networking (SDN) solutions optimize network performance by integrating broadband, dedicated internet, MPLS, Ethernet, private lines, wireless, fiber, and structured wiring into a seamless connectivity solution.",
      icon: connectivity,
      link: "/services/Connectivity",
    },
    {
      title: "IoT Intelligent Smart Cities Solutions",
      description:
        "Our DDoS protection service safeguards digital assets and ensures uninterrupted operations, strengthened by advanced Syslog, SIEM, and next-generation firewall solutions.",
      icon: IntelligentSmartCitiesSolutions,
      link: "/services/Intelligent-Smart-Cities-Solutions",
    },
    {
      title: "Cloud Infrastructure",
      description:
        "We deliver flexible private, public, and hybrid cloud solutions, colocation services, AI-driven insights, and secure connectivity to AWS, Azure, and Google Cloud.",
      icon: cloudinfra,
      link: "/services/Cloud-Infrastructure",
    },
    {
      title: "Maritime Systems",
      description:
        "Our marine communications services provide reliable satellite and radio connectivity, along with security cameras, mobile communications, satellite TV, and fire alarm systems for enhanced safety and onboard support.",
      icon: MariTimes,
      link: "/services/Maritime-Systems",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current || window.innerWidth <= 768) return;

      const container = containerRef.current;
      const rect = container.getBoundingClientRect();
      const scrollHeight = container.scrollHeight - window.innerHeight;

      if (rect.top <= 0 && rect.bottom >= window.innerHeight) {
        const progress = Math.abs(rect.top) / scrollHeight;
        setScrollProgress(Math.min(Math.max(progress, 0), 1));
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const maxScroll = Math.max((services.length * 430) - window.innerWidth + 220, 0);
  const translateX = -scrollProgress * maxScroll;

  return (
    <section className="services-wrapper" ref={containerRef}>
      <div className="services-bg services-bg--one" />
      <div className="services-bg services-bg--two" />

      <div className="services-sticky-container">
        <motion.div
          className="services-header"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.6 }}
        >
          <div className="services-badge">Our core capabilities</div>
          <h2 className="services-title">Comprehensive IT solutions for your business</h2>
          <p className="services-subtitle">
            Explore IT projects and services that enhance performance, security, and support long-term business growth.
          </p>
        </motion.div>

        <div className="services-track-wrapper">
          <motion.div
            className="services-track"
            style={{ transform: `translateX(${translateX}px)` }}
          >
            {services.map((service, index) => (
              <motion.div
                className="service-card"
                key={service.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.45, delay: index * 0.08 }}
              >
                <div className="service-card__shine" />
                <div className="service-icon-wrapper">
                  <img src={service.icon} alt={service.title} className="service-icon" />
                </div>

                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>

                <button
                  className="service-btn"
                  onClick={() => navigate(service.link)}
                >
                  Learn More
                </button>
              </motion.div>
            ))}
          </motion.div>
        </div>

        <div className="scroll-indicator">
          <div
            className="scroll-progress-bar"
            style={{ width: `${Math.max(scrollProgress * 100, 8)}%` }}
          />
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
